import * as React from "react";
// import PropTypes from "prop-types";
import Sidebar from "./sidebar";

function Dashboard() {
  return <Sidebar title={"dashboar"}>Test</Sidebar>;
}

export default Dashboard;
